import React from "react";
import { Dialog } from "@vitalsource/vstui";
import { t } from "../../../core/translate";
import { connect } from "react-redux";
import { actions as modalActions } from "../../../../redux/modals";

const InstructorModal = ({ closeModal }) => (
  <Dialog
    open
    key="AutoSharingInstructorModal"
    rootSelector="#bookshelf"
    size="medium"
    onRequestClose={closeModal}
    title={t(`auto-assign.instructor-handoff-title`)}
    primaryActionButton={{
      label: t("main-menu.got-it", "Got It"),
      onClick: closeModal
    }}
  >
    <p>{t(`auto-assign.instructor-handoff-text`)}</p>
  </Dialog>
);

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(modalActions.closeModal())
});

export default connect(
  null,
  mapDispatchToProps
)(InstructorModal);
